import Table from "components/DataTable/Table";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { convertSqlTimestampToDate } from "utils/UtilityFuncs";
import * as XLSX from "xlsx";

export default function PurchaseIssueHistory({ purchaseOrder }) {
  /*   All States
   ********************************************* */

  const [showModal, setShowModal] = useState(false);
  const [issueData, setIssueData] = useState(null);

  /*   All Functions
   ********************************************* */
  // get issue history again lotId
  // Export issueData to Excel
  const exportToExcel = () => {
    if (!issueData || issueData.length === 0) return;
    const worksheet = XLSX.utils.json_to_sheet(
      issueData.map((item) => ({
        ID: item.issueId,
        "Lot #": item.lotId,
        "Order Id": item.orderId,
        "Issued Qty": item.qty,
        "Issue date": convertSqlTimestampToDate(item.issueDate),
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "IssueHistory");
    XLSX.writeFile(workbook, "IssueHistory.xlsx");
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (purchaseOrder && showModal) {
        setIssueData(purchaseOrder?.m_issues);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [purchaseOrder, showModal]);

  const btn = () => {
    return (
      <div className="text-end me-1 ">
        <button
          disabled={!issueData || issueData.length === 0}
          className="btn btn-success"
          onClick={exportToExcel}
        >
          Export ( {issueData ? issueData.length : 0} )
        </button>
      </div>
    );
  };
  const table_head = ["ID", "Lot #", "Order Id", "Issued Qty", "Issue date"];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="">{item?.issueId}</td>
      <td className="">{item?.lotId}</td>
      <td className="">{item?.orderId}</td>
      <td className="">{item?.qty}</td>
      <td className="">{convertSqlTimestampToDate(item?.issueDate)}</td>
    </tr>
  );

  return (
    <div>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(true);
        }}
        className="btn btn-sm btn-primary"
      >
        History
      </button>

      <Modal
        size="lg"
        contentClassName="bg-transparent"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Body
          className="bg-white custom-border-radius px-3 py-2"
          style={{
            width: "600px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h3>Issue History</h3>
            <button
              onClick={() => setShowModal(false)}
              className="btn btn-sm btn-secondary"
            >
              Close
            </button>
          </div>
          <hr className="mb-3 mt-0" />
          <div className="d-flex justify-content-between align-items-start pb-2">
            <div className="w-50 ">
              <h4 className="fw-bold mb-1 border-bottom">Purchase History</h4>
              <div className="row ">
                <div className="col-md-6 fw-bold">Purchased Qty</div>
                <div className="col-md-6">{purchaseOrder?.purchasedQty}</div>
              </div>
              <div className="row ">
                <div className="col-md-6 fw-bold">Available Qty</div>
                <div className="col-md-6">{purchaseOrder?.qty}</div>
              </div>
              <div className="row ">
                <div className="col-md-6 fw-bold">Purchase Date</div>
                <div className="col-md-6">
                  {convertSqlTimestampToDate(purchaseOrder?.createdAt)}
                </div>
              </div>
            </div>
            <div className="w-50 text-nowrap ps-4">
              <h4 className="fw-bold mb-1 border-bottom">Return History</h4>
              <div className="row ">
                <div className="col-md-6 fw-bold ">Returned Qty</div>
                <div className="col-md-6">
                  {purchaseOrder?.returnQty || "-"}
                </div>
              </div>
              <div className="row ">
                <div className="col-md-6 fw-bold">Return Date</div>
                <div className="col-md-6">
                  {purchaseOrder?.returnDate
                    ? convertSqlTimestampToDate(purchaseOrder?.returnDate)
                    : "-"}
                </div>
              </div>
              <div className="row ">
                <div className="col-md-6 fw-bold">Sold Qty</div>
                <div className="col-md-6">{purchaseOrder?.soldQty || "-"}</div>
              </div>
              <div className="row ">
                <div className="col-md-6 fw-bold">Sell Date</div>
                <div className="col-md-6">
                  {purchaseOrder?.sellDate
                    ? convertSqlTimestampToDate(purchaseOrder?.sellDate)
                    : "-"}
                </div>
              </div>
            </div>
          </div>

          <hr className="mb-3 mt-0" />
          <Table
            buttons={btn}
            table_head={table_head}
            table_body={table_body}
            table_data={issueData || []}
            searchMaxWidth={200}
            defaultLimit={5}
          />
          <hr />
          {/* Total of Issue qty */}
          {issueData && issueData.length > 0 && (
            <div className="d-flex justify-content-center">
              <h5 className="text-secondary">
                Total Issue Qty:{" "}
                {issueData.reduce((acc, item) => acc + item.qty, 0)?.toFixed(3)}
              </h5>
            </div>
          )}
          {issueData && issueData.length === 0 && (
            <div className="text-center mt-3">
              <h5>No Issue History Found</h5>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}
